import styled from 'styled-components';
import { makeExternalUrl, trackAnalytics, attachCategorySlug, attachLocale } from '../../../../lib/utils';
import { DOM_SEARCH_RESULTS } from '../../../../lib/constants';
import MediaQueryHelper from '../../../templates/MediaQueryHelper';

const CategoryCardAnchor = styled.a`
  padding: ${({ theme }) => theme.unit(3)} ${({ theme }) => theme.unit(2)}; 
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;
  border: 1px solid ${(p) => p.theme.c.border.primary};
  text-decoration: none;
  cursor: pointer;
  ${({ theme }) => theme['elevation-shadow']['1']}

  :hover {
    ${({ theme }) => theme['elevation-shadow']['2']}
  }
`;

const DesktopCategoryCardAnchor = styled(CategoryCardAnchor)`
  width: ${p => p.theme.unit(22)}; 
  height: 100%;
`;

const CategoryIconImg = styled.img`
  max-height: 100%;
  max-width: 100%;
`;

const CategoryNameDiv = styled.div`
  ${({ theme }) => theme.typographyRebrand.body.lg}
  color: ${p => p.theme.c.text.interactive};
  padding-top: ${p => p.theme.unit(3)}; 
  text-align: center;
  width: 100%;
`;

const MobileCategoryCardAnchor = styled(CategoryCardAnchor)`
  width: ${p => p.theme.unit(16.5)}; 
  height: 100%;
`;

const CategoryCard = (props) => {
  const {
    slug,
    name,
    categoryIconUrl,
    tags,
    locale,
    dataLayerId,
    dataContextContainer,
    dataIndex,
  } = props;

  const resolvedIconUrl = makeExternalUrl(categoryIconUrl);
  const resolvedCategoryUrl = attachLocale(attachCategorySlug(slug), locale);
  const track = trackAnalytics(DOM_SEARCH_RESULTS, `${slug}-category`, resolvedCategoryUrl, tags);

  const DesktopBody = () => (
    <DesktopCategoryCardAnchor
      id={track.dataTrackingId}
      href={track.url}
      data-track-id={track.dataTrackingId}
      data-track-click={track.dataTrack}
      data-layer-source-id={dataLayerId}
      data-context-container={dataContextContainer}
      data-index={dataIndex} >
      <CategoryIconImg src={resolvedIconUrl} alt=""/>
      <CategoryNameDiv>{ name }</CategoryNameDiv>
    </DesktopCategoryCardAnchor>
  );

  const MobileBody = () => (
    <MobileCategoryCardAnchor
      id={track.dataTrackingId}
      href={track.url}
      data-track-id={track.dataTrackingId}
      data-track-click={track.dataTrack}
      data-layer-source-id={dataLayerId}
      data-context-container={dataContextContainer}
      index={dataIndex} >
      <CategoryIconImg src={resolvedIconUrl} alt=""/>
      <CategoryNameDiv>{ name }</CategoryNameDiv>
    </MobileCategoryCardAnchor>
  );

  const renderComp = (
    <MediaQueryHelper
      desktopChildren={DesktopBody()}
      mobileChildren={MobileBody()} />);
  return renderComp;
};

export default CategoryCard;
